import React from "react";
import MobileToolControls from "./MobileToolControls";
import "./MobileControls.css";

class MobileControls extends React.Component {
  render() {
    return (
      <div className="mobile-controls">
        <MobileToolControls
          onToggleGuides={this.props.onToggleGuides}
          guidesVisible={this.props.guidesVisible}
        />
      </div>
    );
  }
}

export default MobileControls;
